<template>
  <div>

    <fieldset>

			<h2>
				Nutriënten
			</h2>
			<p>Vul nu het buisje met water. Daarvoor vul je je emmer of bak met water, breng het water enigszins in beweging zodat het goed gemengd is. Houd het buisje en de dop vervolgens beide onder water en draai de dop er onder water op zodat er geen lucht in het buisje zit. Vul hieronder de code van je buisje in. Is er iets misgegaan of ben je je buisje kwijtgeraakt vink dat dan aan om het ons te laten weten.</p>

			<input-text 
				label="Code reageerbuis" 
				name="testCode" 
				v-model="localMeasurement.testCode" 
				subtitle="De code van het reageerbuisje begint met een hoofdletter en heeft vervolgens 3 cijfers. Let goed op dat je geen typefoutjes maakt, hiermee worden je nutriënten gegevens namelijk gekoppeld aan je online metingen."
				placeholder="Bijv. T184"
				:pattern="true"
				error="Dit is geen geldige code"
			/>

			<SingleCheckbox
					name="measurement_failed"
					v-model="localMeasurement.failed"
					label="Ik stuur geen buisje op"
          :value="1"
					text="Er is iets misgegaan en ik stuur geen buisje op"
			/>

    </fieldset>
    <nav>
      <button @click.prevent="$emit('back')" type="button" class="btn-prev">Terug</button>
      <button @click.prevent="$emit('save', localMeasurement)" class="btn-next" :disabled="!fieldsComplete">Volgende</button>
    </nav>
  </div>
</template>

<script>
import FormStep from "./FormStep.vue";
import SingleCheckbox from "./components/SingleCheckbox.vue";
import InputText from "./components/InputText.vue";

export default {
  name: "FormStep6",
	components: {InputText, SingleCheckbox},
  mixins: [FormStep],
  data(){
    return {
    }
  },
	computed: {
		dynamicFieldRequirements(){
			const result = {};
			if(!this.localMeasurement.testCode){
				console.log('missing testcode');
				result.failed = ['required'];
			}
			return result;
		}
	},

}
</script>

<style scoped>

</style>
